import React from 'react';
import {
    Chart,
    Series,
    CommonSeriesSettings,
    Legend,
    Tooltip,
    ArgumentAxis,
    ValueAxis,
} from 'devextreme-react/chart';
import { Size } from "devextreme-react/vector-map";
import { Stack } from '@fluentui/react/lib/Stack';
import { DetailsList, SelectionMode } from '@fluentui/react/lib/DetailsList';
import { MyContext } from '../../../../context';

class StackedBarQM extends React.Component {

    static contextType = MyContext
    constructor(props) {
        super(props);
        this.legendClickHandler = this.legendClickHandler.bind(this);
        this.onColumnClick = this.onColumnClick.bind(this);
        this.state = {
            sortedItems: [],
            columns: [],
        };
    }

    legendClickHandler(e) {
        this.props.changeSectionInfo(e.target.name)
    }

    componentDidMount() {
        if (this.props.sectionName !== undefined) {
            const sortedItems = this.initializeSortedItems(this.props.data);
            this.setState({
                sortedItems,
                columns: [
                    { key: 'column1', name: this.context.getTranslation("compliance", "UserName"), fieldName: 'userName', minWidth: 100, maxWidth: 200, isResizable: true, onColumnClick: this.onColumnClick },
                    { key: 'column2', name: this.context.getTranslation("compliance", "Evaluation"), fieldName: 'evaluation', minWidth: 100, maxWidth: 200, isResizable: true, onColumnClick: this.onColumnClick },
                    { key: 'column3', name: this.context.getTranslation("compliance", "Score"), fieldName: 'score', minWidth: 50, maxWidth: 100, isResizable: true, isSorted: true, isSortedDescending: false, onColumnClick: this.onColumnClick },
                ]
            });
        }
    }

    onColumnClick(event, column) {
        const { columns, sortedItems } = this.state;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach(newCol => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        const newSortedItems = this.copyAndSort(sortedItems, currColumn.fieldName, currColumn.isSortedDescending);
        this.setState({
            columns: newColumns,
            sortedItems: newSortedItems,
        });
    }

    copyAndSort(items, columnKey, isSortedDescending) {
        const key = columnKey;
        return items.slice(0).sort((a, b) => {
            let aValue = a[key];
            let bValue = b[key];

            if (key === 'score') {
                if (aValue === undefined) return isSortedDescending ? -1 : 1;
                if (bValue === undefined) return isSortedDescending ? 1 : -1;
            }

            if (aValue < bValue) {
                return isSortedDescending ? 1 : -1;
            }
            if (aValue > bValue) {
                return isSortedDescending ? -1 : 1;
            }
            return 0;
        });
    }

    getDataTableFromDataChart(dataChart) {
        let dataTable = []
        let sectionsSeries = []
        if (dataChart !== null) {
            dataChart.forEach(d => {
                if (d.items !== null) {
                    sectionsSeries = d.items.map(d => d.args)
                }
            })
            //reduce data to be used in the chart
            dataChart = dataChart.map(d => {
                const result = d.items?.reduce((acc, currentItem) => {
                    acc[currentItem.args] = currentItem.value;
                    return acc;
                }, {});
                const userName = this.props.persons.filter(p => p.userId === d.userId)[0]?.name ?? ""
                return { userName: userName, ...result }
            })
            sectionsSeries.forEach((s, i) => {
                dataChart.forEach((d, x) => {
                    dataTable.push({
                        key: i + "_" + x,
                        userName: d.userName,
                        evaluation: s,
                        score: d[s]
                    });
                })
            })
        }
        return dataTable
    }

    initializeSortedItems(dataChart) {
        const datatable = this.getDataTableFromDataChart(dataChart);
        const sortedItems = this.copyAndSort(datatable, 'score', false);
        return sortedItems;
    }

    customizeTooltipScorecardPerformance = ({ seriesName, valueText }) => {
        let values = this.props.data?.map(d => {
            return d.value
        })
        let total = values !== null && values.length > 0 ? values[1] + values[0] : "?"
        return {
            text: `${valueText}/${total}`,
        };
    }

    customizeTooltipSectionUser = ({ seriesName, valueText }) => {
        //console.log(seriesName, valueText)
        if (this.props.data.length > 0) {
            const randomResult = this.props.data[0] //for total calculation every section is the same i take one
            const section = randomResult.items.filter(i => i.args === seriesName)
            if (section.length > 0) {
                const total = section[0].total
                return {
                    text: `${valueText}/${total}`,
                };
            }
        }
        return ""
    }

    getDefaultVisualRangeFromSectionsOrEvaluation = () => {
        if (this.props.data.length > 0) {
            const randomResult = this.props.data[0] //for total calculation every section is the same i take one
            let total = 0;
            randomResult.items?.forEach(i => {
                total = total + i.total
            })
            return [0, total]
        } else {
            return undefined
        }
    }

    render() {
        let _allItems = []
        let columns = []
        if (this.props.sectionName !== undefined) {
            _allItems = this.state.sortedItems;
            columns = this.state.columns;
        }

        let dataChart = this.props.data
        if (this.props.type === "scorecardPerformance") {
            let defaultVisualRange;
            if (dataChart !== null) {
                //reduce data to be used in the chart
                let values = dataChart.map(d => {
                    return d.value
                })
                dataChart = [{ name: this.props.name, yes: values[1], no: values[0] }]
                const valueToReach = values[1] + values[0]
                defaultVisualRange = [0, valueToReach]
            }
            return (
                <Chart
                    id="chart"
                    ref={this.props.reference}
                    dataSource={dataChart}
                    palette={this.props.palette}
                >
                    <ArgumentAxis defaultVisualRange={defaultVisualRange}> </ArgumentAxis>
                    <ValueAxis defaultVisualRange={defaultVisualRange} />
                    <CommonSeriesSettings
                        ignoreEmptyPoints={true}
                        argumentField="name" type="stackedBar"
                    />
                    <Series
                        valueField="yes"
                        name={this.context.getTranslation("compliance", "scoreAchived")}
                        color={this.props.palette[1]}

                    />
                    <Series
                        valueField="no"
                        name={this.context.getTranslation("compliance", "scoreNotAchived")}
                        color={this.props.palette[0]}

                    />
                    <Legend
                        margin={0}
                        horizontalAlignment="center"
                        verticalAlignment="bot"
                    />
                    <Tooltip enabled={true} container="#chart-modal" customizeTooltip={this.customizeTooltipScorecardPerformance} />
                    <Size
                        height={this.props.size.height}
                        width={this.props.size.width}
                    />
                </Chart>
            );
        }
        else if (this.props.type === "sectionUser") {
            //to managed the series of the chart
            let sectionsSeries = []
            if (dataChart !== null) {
                dataChart.forEach(d => {
                    if (d.items !== null) {
                        sectionsSeries = d.items.map(d => d.args)
                    }
                })
            }
            if (sectionsSeries.length === 0) {
                return <div style={{ marginTop: "140px", marginBottom: "180px" }}>No data</div>
            } else {
                //reduce data to be used in the chart
                dataChart = dataChart.map(d => {
                    const result = d.items?.reduce((acc, currentItem) => {
                        acc[currentItem.args] = currentItem.value;
                        return acc;
                    }, {});
                    const userName = this.props.persons.filter(p => p.userId === d.userId)[0]?.name ?? ""
                    return { userName: userName, ...result }
                })
                const defaultVisualRange = this.getDefaultVisualRangeFromSectionsOrEvaluation()

                return (<Stack>
                    <Stack.Item>
                        <Chart
                            id="chart"
                            ref={this.props.reference}
                            dataSource={dataChart}
                            palette={this.props.palette}
                            {...(this.props.isModal && this.props.changeSectionInfo != undefined && { onLegendClick: this.legendClickHandler })}
                        >
                            <ArgumentAxis defaultVisualRange={defaultVisualRange}> </ArgumentAxis>
                            <ValueAxis defaultVisualRange={defaultVisualRange} />
                            <CommonSeriesSettings
                                ignoreEmptyPoints={true}
                                argumentField="userName" type="stackedBar"
                            />
                            {sectionsSeries.map(s => {
                                return (
                                    <Series
                                        key={s}
                                        valueField={s}
                                        name={s}

                                    />
                                )
                            })}
                            <Legend
                                margin={0}
                                horizontalAlignment="center"
                                verticalAlignment="bottom"
                                font={{ size: sectionsSeries.length > 6 ? "9px" : "12px" }}
                            />
                            <Tooltip enabled={true} container="#chart-modal" customizeTooltip={this.customizeTooltipSectionUser} />
                            <Size
                                height={this.props.size.height}
                                width={this.props.size.width}
                            />
                        </Chart>
                    </Stack.Item>
                    {/*table to show the data in case of sectionName is not null*/}
                    {this.props.sectionName !== undefined && <Stack.Item style={{ margin: "10px" }}>
                        <Stack>
                            <Stack.Item>
                                <span>{this.context.getTranslation("compliance", "section") + ": " + this.props.sectionName}</span>
                            </Stack.Item>
                            <Stack.Item>
                                <DetailsList
                                    items={_allItems}
                                    columns={columns}
                                    selectionMode={SelectionMode.none}
                                />
                            </Stack.Item>
                        </Stack>
                    </Stack.Item>}
                </Stack>
                )
            }

        }

    }
}

export default StackedBarQM;
